export default function Games ({ active }) {
	return (
		<svg width={24} height={24} viewBox='0 0 24 24'>
			<path d='M 8 4 C 10 5 14 5 16 4 C 24 0 28 28 20 20 C 16 16 8 16 4 20 C -4 28 0 0 8 4' style={{stroke: active ? 'transparent' : 'var(--header-text-color-hsl)', strokeWidth: 2, fill: active ? 'var(--header-text-color-hsl)' : 'transparent'}} />
			<circle cx={7} cy={9} r={2} style={{stroke: active ? 'transparent' : 'var(--header-text-color-hsl)', strokeWidth: 2, fill: active ? 'var(--main-color-hsl)' : 'transparent'}} />
			<circle cx={17} cy={9} r={2} style={{stroke: active ? 'transparent' : 'var(--header-text-color-hsl)', strokeWidth: 2, fill: active ? 'var(--main-color-hsl)' : 'transparent'}} />
		</svg>
	);
};